<template lang="html">
	<div class="activityContainer">
		<div class="title">精彩活动</div>
		<div class="sub-title">君弘财富俱乐部持续面向君弘财富会员开展形式多样、轻松高雅的各类活动，涵盖“境外投资、财富传承、子女教育、公益活动”多个系列活动。为您创造良好的互动交流平台，打造优质社交圈。</div>
		<div class="activityBox">
			<div class="imgcontainer" v-for="(item,index) in activityArray" v-if="index < 4" v-on:click="toDetailInfo(index)">
				<router-link :to="{ name:'activityDetail',params: { infoId: item.INFO_ID},query: { typeCode: item.TYPE_CODE }}">
					<img v-bind:src="imgSrc+item.PIC_URL.split('|')[0]" />
					<!-- <img src="../../assets/img/index-activity.png"> -->
					<div class="activityColumn">{{item.PROD_NAME}}</div>
					<div class="box-title">
						<div class="activity-title">{{item.TITLE}}</div>
					</div>
				</router-link>
			</div>
			
			<!-- <div class="imgcontainer">
				<img src="../../assets/img/index-activity.png">
				<div class="activityColumn">君弘财富万里行</div>
				<div class="box-title">
					<div class="activity-title">本次活动福建分公司特别为参会客户准备的精致定制纪念品。</div>
				</div>
			</div>
			<div class="imgcontainer">
				<img src="../../assets/img/index-activity.png">
				<div class="activityColumn">君弘财富万里行</div>
				<div class="box-title">
					<div class="activity-title">本次活动福建分公司特别为参会客户准备的精致定制纪念品。</div>
				</div>
			</div>
			<div class="imgcontainer">
				<img src="../../assets/img/index-activity.png">
				<div class="activityColumn">君弘财富万里行</div>
				<div class="box-title">
					<div class="activity-title">本次活动福建分公司特别为参会客户准备的精致定制纪念品。</div>
				</div>
			</div> -->
		</div>
	</div>
</template>
<script>
	import {commonPicUrl} from '../../common/url.js'
	export default {
	  	name: 'activity',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,	
		  	}
	  	},
	  	props:['activityArray'],
	  	methods:{
	  		//跳转资讯详情
	  		toDetailInfo:function(index){
	  			let sequence = parseInt(index);
	  			localStorage.setItem('activitySequence',sequence);
	  		},
	  	}
	}
</script>
<style lang="less" scoped>
	.activityContainer{
		padding:0px 40px;
		width:100%;
		.title{
			width:100%;
			height:40px;
			font-size:32px;
			color:#ad8f5a;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
			font-weight:bold;
		}
		.sub-title{
			margin-top:20px;
			width:100%;
			font-size:24px;
			color:#999999;
			letter-spacing:0;
			line-height:40px;
			text-align:left;
		}
		.activityBox{
			margin-bottom:30px;
			width:100%;
			.imgcontainer{
				width:100%;
				border-radius:10px;
				margin-top:20px;
				position:relative;	
				height:340px;	
				img{
					width:100%;
					max-height:340px;
				}
				.box-title{
					width:100%;
					// height:120px;
					border-radius:0 0 10px 10px;
					position:absolute;
					bottom:0;
					padding:15px 20px;
					background-image:linear-gradient(-180deg, rgba(255,255,255,0.00) 4%, #4a4136 97%);
					font-size:28px;
					color:#ffffff;
					letter-spacing:0;
					text-shadow:0 2px 4px rgba(0,0,0,0.50);
					text-align:left;
					.activity-title{
						width:100%;
						height:40px;
						line-height:40px;
						text-overflow:ellipsis;
						overflow: hidden;
				    	display: -webkit-box;
		    			-webkit-line-clamp: 1;
		    			-webkit-box-orient: vertical;
		    			word-break:break-all;
		    			-webkit-box-orient: vertical;
					}
				}
				.activityColumn{
					position:absolute;
					top:20px;
					right:20px;
					background:rgba(173,143,90,0.90);
					border-radius:8px;
					height:40px;
					line-height:40px;
					padding:0 10px;
					text-align:center;
					font-size:24px;
					color:#ffffff;
					letter-spacing:0;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/activity.vue